import React from "react";
import { Typography, TextField, Button, Stack, Link } from "@mui/material";
import PageShell from "../components/PageShell";
import PageTitle from "../components/PageTitle";

export default function Contact() {
  return (
    <PageShell>
      <PageTitle>Contact Us</PageTitle>
      <Typography variant="body1" sx={{ mb: 2 }}>
        Send us a message and we’ll get back to you.
      </Typography>
      <Stack spacing={2}>
        <TextField label="Name" fullWidth />
        <TextField label="Email" type="email" fullWidth />
        <TextField label="Message" multiline minRows={4} fullWidth />
        <Button variant="contained">Send</Button>
      </Stack>
      <Typography variant="body2" sx={{ mt: 3 }}>
        Or email us directly:{" "}
        <Link href="mailto:info@mtinnotech.org">info@mtinnotech.org</Link>
      </Typography>
    </PageShell>
  );
}
